export default __webpack_public_path__ + "static/media/GAN7.da686091.png";